import { match as Match, matchPath, RouteProps } from "react-router-dom";
import { Location } from "history";

const path = ["sign-in", "sign-up", "qr", "send-reset-link"];

const props: RouteProps = {
  path: path.map(path => `/settings/${path}`),
  exact: true,
};

export const isAccountActive = (match: Match, { pathname }: Location) => (
  Boolean(match || matchPath(pathname, props))
);
